import SmartFeedEngine from "SmartFeed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { GRAPHIC_DESIGNER } from "@/constants/expert-constants";

export const useOrgCommunityGraphicDesignerExpertiseFeedStore = defineSmartFeedPiniaStore(
  "org-community-graphic-designer-expertise-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      defaultFilterValues: {
        expertise: {
          key: "expertise",
          payload: GRAPHIC_DESIGNER,
        },
      },
      metadata: {
        lastId: Number.MAX_SAFE_INTEGER,
      },
    }),
    getters: {
      feedUrl() {
        return "/expert/community";
      },
    },
  },
);
